/*
(i) Код потрапляє у підсумковий файл,
тільки коли викликана функція,
наприклад flsFunctions.spollers();
Або коли імпортовано весь файл,
наприклад, import "files/script.js";
Невикористовуваний (не викликаний)
код у підсумковий файл не потрапляє.

Якщо ми хочемо додати модуль
слід його розкоментувати
*/

// Увімкнути/вимкнути FLS (Full Logging System) (в роботі)
// window["FLS"] = false;
// import { Fancybox } from "@fancyapps/ui";
// import "@fancyapps/ui/dist/fancybox/fancybox.css";
// Fancybox.bind("[data-fancybox]", {});
// Підключення основного файлу стилів



//============================================================================================================================================================================================================================================
// React ========================================================================================================================================================================================================================================================
//============================================================================================================================================================================================================================================
// import Index from './react/Index.jsx';
//============================================================================================================================================================================================================================================

// ========================================================================================================================================================================================================================================================
// Функціонал ========================================================================================================================================================================================================================================================
// ========================================================================================================================================================================================================================================================
import * as flsFunctions from "./files/functions.js";

/* Перевірка підтримки webp, додавання класу webp або no-webp для HTML */
/* (i) необхідно для коректного відображення webp із css */
// flsFunctions.isWebp();
/* Додавання класу touch для HTML якщо браузер мобільний */
// flsFunctions.addTouchClass();
/* Додавання loaded для HTML після повного завантаження сторінки */
// flsFunctions.addLoadedClass();
/* Модуль для роботи з меню (Бургер) */
flsFunctions.menuInit();
/* Враховування плаваючої панелі на мобільних пристроях при 100vh */
// flsFunctions.fullVHfix();
/* Форматування чисел */
// import './libs/wNumb.min.js';

/*
Модуль "Спойлери"
Документація: https://template.fls.guru/template-docs/modul-spojlery.html
Сніппет (HTML): spollers
*/
// flsFunctions.spollers();

/*
Модуль "Таби"
Документація: https://template.fls.guru/template-docs/modul-taby.html
Сніппет (HTML): tabs
*/
flsFunctions.tabs();

/*
Модуль "Показати ще"
Документація: https://template.fls.guru/template-docs/modul-pokazat-eshhjo.html
Сніппет (HTML): showmore
*/
// flsFunctions.showMore();

/*
Модуль "Ефект хвиль"
Документация: https://template.fls.guru/template-docs/modul-ripple-effect.html
Сниппет (HTML):
*/
// flsFunctions.rippleEffect();

/*
Модуль "Кастомний курсор"
Документация:
Сниппет (HTML):
*/
// flsFunctions.customCursor(true);

/*
Модуль "Попапи"
Документація: https://template.fls.guru/template-docs/funkcional-popup.html
Сніппет (HTML): pl, pop
*/
// import './libs/popup.js'

/*
Модуль паралаксу мишею
Документація: https://template.fls.guru/template-docs/modul-animacii-parallaks-obektov-pri-dvizhenii-myshi.html
*/
// import './libs/parallax-mouse.js'

// ========================================================================================================================================================================================================================================================
// Робота з формами ========================================================================================================================================================================================================================================================
// ========================================================================================================================================================================================================================================================
// import * as flsForms from "./files/forms/forms.js";

/* Робота з полями форми */
/* Документація: https://template.fls.guru/template-docs/rabota-s-formami.html */
/*
flsForms.formFieldsInit({
  viewPass: false,
  autoHeight: false
});
*/
/* Надсилання форми */
/* Документація: https://template.fls.guru/template-docs/rabota-s-formami.html */
// flsForms.formSubmit();

/* Модуль форми "кількість" */
// flsForms.formQuantity();

/* Модуль зіркового рейтингу */
// flsForms.formRating();

/* Модуль роботи з select. */
// import './libs/select.js'

/* Модуль роботи з календарем */
// import './files/forms/datepicker.js'

/* (У роботі) Модуль роботи з масками.*/
/*
Підключення та налаштування виконується у файлі js/files/forms/inputmask.js
Документація по роботі у шаблоні:
Документація плагіна: https://github.com/RobinHerbots/inputmask
Сніппет(HTML):
*/
// import "./files/forms/inputmask.js";

/* Модуль роботи з повзунком */
/*
Підключення та налаштування виконується у файлі js/files/forms/range.js
Документація по роботі у шаблоні:
Документація плагіна: https://refreshless.com/nouislider/
Сніппет (HTML): range
*/
// import "./files/forms/range.js";

/* Модуль роботи з підказками (tippy) */
/*
Підключення плагіна Tippy.js та налаштування виконується у файлі js/files/tippy.js
Документація по роботі у шаблоні:
Документація плагіна: https://atomiks.github.io/tippyjs/
Сніппет (HTML): tip (додає атрибут з підказкою для html тега)
*/
// import "./files/tippy.js";

// ========================================================================================================================================================================================================================================================
// Робота зі слайдером (Swiper) ========================================================================================================================================================================================================================================================
// ========================================================================================================================================================================================================================================================
/*
Налаштування підключення плагіна слайдера Swiper та нових слайдерів виконується у файлі js/files/sliders.js
Документація по роботі у шаблоні: https://template.fls.guru/template-docs/rabota-so-slajderom-swiper.html
Документація плагіна: https://swiperjs.com/
Сніппет(HTML): swiper
*/
import "./files/sliders.js";

// ========================================================================================================================================================================================================================================================
// Модулі роботи з прокручуванням сторінки ========================================================================================================================================================================================================================================================
// ========================================================================================================================================================================================================================================================

/*
Зміна дизайну скроллбару
Документація по роботі у шаблоні: У HTML додаємо до блоку атрибут data-simplebar
Документація плагіна: https://github.com/Grsmto/simplebar/tree/master/packages/simplebar
Сніппет(HTML): 
*/
import './files/scroll/simplebar.js';

// Ліниве (відкладене) завантаження картинок
// Документація по роботі у шаблоні: https://template.fls.guru/template-docs/modul-lenivaya-podgruzka-lazy-loading.html
// Документація плагіна: https://github.com/verlok/vanilla-lazyload
// Сніппет(HTML):
// import './files/scroll/lazyload.js';

// Спостерігач за об'єктами з атрибутом data-watch
// Документація: https://template.fls.guru/template-docs/modul-nabljudatel-za-poyavleniem-elementa-pri-skrolle.html
// Сніппет(HTML):
// import './libs/watcher.js'

// Модуль поекранної прокрутки
// Документація: https://template.fls.guru/template-docs/modul-poekrannoj-prokrutki-stranicy-fullpage.html
// Сніппет(HTML):
// import './libs/fullpage.js'

// Модуль паралаксу
// Документація: https://template.fls.guru/template-docs/paralaks-pri-skroli.html
// Сніппет(HTML):
// import './libs/parallax.js'

// Функції роботи скролом
// import * as flsScroll from "./files/scroll/scroll.js";

// Плавна навігація по сторінці
// Документація: https://template.fls.guru/template-docs/modul-plavnoj-navigacii-po-stranice.html
// flsScroll.pageNavigation();

// Функціонал додавання класів до хедеру під час прокручування
// Документація: https://template.fls.guru/template-docs/modul-dobavleniya-klassov-k-shapke-pri-prokrutke-stranicy.html
// flsScroll.headerScroll();

// Модуль анімація цифрового лічильника
// Документація: https://template.fls.guru/template-docs/modul-animacii-cifrovogo-lichilnika.html
// Сніппет(HTML):
// flsScroll.digitsCounter();

// 
// 
// 

flsFunctions.pPixelInit();

// Функція конвертації зображень з формату svg в інлайн svg
// Використовується для заміни зображень, що завантажені з сервера, на інлайн-схеми
// для можливості їх зміни з допомогою css
//
// query - селектор зображень, які потрібно конвертувати
// callback - функція, яка викликається після заміни всіх зображень
flsFunctions.convertImages('.svg');
// 

// ========================================================================================================================================================================================================================================================================
// Галерея ========================================================================================================================================================================================================================================================
// ========================================================================================================================================================================================================================================================
/*
Документація по роботі у шаблоні: 
Документація плагіна: https://www.lightgalleryjs.com/docs/
Сніппет(HTML):
*/
// import "./files/gallery.js";
import "./files/fancybox.js";

// ========================================================================================================================================================================================================================================================
// Масонрі сітка ========================================================================================================================================================================================================================================================
// ========================================================================================================================================================================================================================================================
/*
Документація по роботі у шаблоні:
Документація плагіна: 
Сніппет(HTML):
*/
// import "./files/isotope.js";

// ========================================================================================================================================================================================================================================================
// Інші плагіни ============================================================================================================================================================================================================================================================================================================
// ========================================================================================================================================================================================================================================================

/* Динамічний адаптив */
// Документація: https://template.fls.guru/template-docs/dinamicheskij-adaptiv.html
import "./libs/dynamic_adapt.js";

// ========================================================================================================================================================================================================================================================
// Інше ========================================================================================================================================================================================================================================================
// ========================================================================================================================================================================================================================================================
/* Підключаємо файли зі своїм кодом */
// import "./files/script.js";
//============================================================================================================================================================================================================================================
// const swiper = new Swiper('.swiper-container', {
// 	slidesPerView: 3, // Количество видимых слайдов
// 	spaceBetween: 30,
// 	navigation: {
// 	  nextEl: '.swiper-button-next',
// 	  prevEl: '.swiper-button-prev',
// 	},
// 	on: {
// 	  slideChange: function () {
// 		// Логика обновления большого изображения и описания справа
// 		const activeSlide = swiper.slides[swiper.activeIndex];
// 		const largeImage = document.querySelector('.book-slider__right img');
// 		const bookTitle = document.querySelector('.book-description h2');
// 		const bookDescription = document.querySelector('.book-description p');

// 		// Здесь обновите `src` для большого изображения и текст для описания
// 		largeImage.src = activeSlide.querySelector('img').src;
// 		bookTitle.textContent = 'Название книги'; // Добавьте здесь логику для замены названия
// 		bookDescription.textContent = 'Описание книги'; // Добавьте здесь логику для замены описания
// 	  }
// 	}
//   });


flsFunctions.projectStatsSwitcher();


// Прокрутка до кінця по горизонталі
document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('.traffic-chart__scroll');
  if (el) {
    el.scrollLeft = el.scrollWidth;
  }
});

function getWindowWidth() {
  const windowWidth = window.innerWidth;
  return windowWidth
}


document.addEventListener('DOMContentLoaded', () => {
  const sidebarMenuActive = document.querySelector('.sidebar-menu__active');

  const sidebarMenu = document.querySelector('.sidebar-menu__wrapper ul');

  const sidebarMenuLi = document.querySelectorAll('.sidebar-menu ul li');
  const aanvlugTitleMobile = document.querySelector('.aanvlug-title-mobile');



  if (sidebarMenuActive && sidebarMenu && getWindowWidth() < 767) {
    sidebarMenuActive.addEventListener('click', () => {
      sidebarMenu.classList.toggle('sidebar-menu--open');
    });
  }

  if (getWindowWidth() < 768) {
    sidebarMenuActive.addEventListener('click', () => {
      sidebarMenuLi.forEach(item => {
        item.classList.toggle('open');
      });
    });

    // item.addEventListener('click', () => {
    //   sidebarMenuLi.forEach(el => {
    //     // el.classList.remove('open');
    //     // el.classList.remove('sidebar-menu__active');
    //   });
    //   // item.classList.add('sidebar-menu__active');
    // })
  }
});






document.addEventListener('DOMContentLoaded', () => {
  const faqItem = document.querySelectorAll('.faq__item');

  if (faqItem) {
    faqItem.forEach(item => {
      const faqQuestion = item.querySelector('.faq__question');
      faqQuestion.addEventListener('click', () => {
        item.classList.toggle('open');
      });
    });
  }
});




(function () {

  if (getWindowWidth() > 768) {
    const container = document.getElementById('s-reviews__grid');
    if (!container) return;

    // Збираємо всі початкові айтеми в масив
    const items = Array.from(container.querySelectorAll('.s-reviews__item'));
    if (items.length === 0) return;

    // Очистимо контейнер — потім вставимо колонки
    container.innerHTML = '';

    let idx = 0;
    // Додаємо першу колонку — 4 елементи (або менше, якщо мало)
    const firstCount = Math.min(4, items.length - idx);

    if (firstCount > 0) {
      const col = document.createElement('div');
      col.className = 's-reviews__column';
      for (let i = 0; i < firstCount; i++) {
        col.appendChild(items[idx++]);
      }
      container.appendChild(col);
    }

    // Додаємо наступні колонки — по 3 елементи
    const perCol = 3;
    while (idx < items.length) {
      const col = document.createElement('div');
      col.className = 's-reviews__column';
      for (let i = 0; i < perCol && idx < items.length; i++) {
        col.appendChild(items[idx++]);
      }
      container.appendChild(col);
    }
  }
})();
// 
// 
// 
// 
// 
// 
// 
// 
// 
// 
// 
// 
// 
// 
// 
// 
// 
// 
// 

// Отримуємо елемент статті
// const article = document.querySelector('.case-single__content');

// if (article) {
//   // Підраховуємо кількість символів у тексті статті
//   const text = article.innerText || article.textContent;
//   const charCount = text.length;

//   // Розраховуємо час на читання (1000 символів ≈ 1 хв)
//   const minutes = Math.max(1, Math.ceil(charCount / 1000));

//   // Знаходимо елемент для виводу часу
//   const output = document.querySelector('.single-post__read-time span');
//   if (output) {
//     // Виводимо результат
//     output.textContent = minutes;

//   }
// }



const headers = document.querySelectorAll('.content-for-heads h2, .content-for-heads h3');
const tocContainer = document.querySelector('.sidebar-heads-menu');
const tocList = document.createElement('ul');

const tocLinks = []; // Масив для збереження посилань

headers.forEach((header, index) => {
  const id = `header-id-${index + 1}`;
  header.id = id;

  const li = document.createElement('li');
  const a = document.createElement('a');
  a.href = `#${id}`;
  a.textContent = header.textContent;

  // Обробка кліку — додає клас active
  a.addEventListener('click', (e) => {
    tocLinks.forEach(link => link.classList.remove('active'));
    a.classList.add('active');
  });

  tocLinks.push(a);
  li.appendChild(a);
  tocList.appendChild(li);
});

if (tocContainer) tocContainer.appendChild(tocList);

// Відстеження скролу — оновлення активного пункту
window.addEventListener('scroll', () => {
  let currentId = null;

  headers.forEach((header) => {
    const rect = header.getBoundingClientRect();
    if (rect.top <= 50) currentId = header.id;
  });

  tocLinks.forEach(link => {
    link.classList.toggle('active', link.getAttribute('href') === `#${currentId}`);
  });
});

// 
// 
// 
// 
// 
// 
// 
// 
document.addEventListener('DOMContentLoaded', () => {
  const headerMenuMob = document.querySelector('.header__menu-mob');

  const headerMenu = document.querySelector('.header__menu');

  headerMenuMob.addEventListener('click', () => {
    headerMenu.classList.toggle('active');
  })
});
// 




document.addEventListener('DOMContentLoaded', () => {
  // Перевіряємо чи вже прийнято cookies
  if (document.cookie.indexOf('cookies_accept=true') === -1) {
    // Показуємо блок, якщо кукі немає
    document.querySelector('.cookies').style.display = 'block';
  } else {
    document.querySelector('.cookies').style.display = 'none';
  }

  // Вішаємо клік на кнопку
  document.querySelector('.cookies .btn').addEventListener('click', function (e) {
    e.preventDefault();

    // Ховаємо блок після кліку
    document.querySelector('.cookies').style.display = 'none';

    // Записуємо кукі на 1 рік
    document.cookie = "cookies_accept=true; path=/; max-age=" + (60 * 60 * 24 * 365);
  });
});


/* JS: керування відкриттям/закриттям та вибором мови */
document.addEventListener('DOMContentLoaded', function () {
  const root = document.querySelector('.footer__lang');
  if (!root) return;

  const wpmlList = root.querySelector('#lang_menu .wpml-ls-legacy-list-horizontal');
  if (!wpmlList) return;

  // Поточний елемент (li з класом current)
  const currentLi = wpmlList.querySelector('li.wpml-ls-current-language');

  // Тогл відкриття меню
  function toggleOpen() {
    root.classList.toggle('open');
  }

  function closeMenu() {
    root.classList.remove('open');
  }

  // Клік всередині контейнера
  root.addEventListener('click', function (e) {
    const clickedLi = e.target.closest('li');
    const clickedA = e.target.closest('a');

    // Якщо клікнули по поточній мові — тільки тогл меню, не переходити по лінку
    if (clickedLi && clickedLi.classList.contains('wpml-ls-current-language')) {
      e.preventDefault();
      toggleOpen();
      return;
    }

    // Якщо клікнули по іншій мові — дозволяємо перехід (натуральна поведінка браузера).
    // Але для плавності можна вручну перейти:
    if (clickedA && clickedLi && !clickedLi.classList.contains('wpml-ls-current-language')) {
      // Не блокуємо — просто закриємо меню перед переходом (необов'язково)
      closeMenu();
      // Якщо хочемо — можна перейти через JS (але зазвичай не потрібно):
      // window.location.href = clickedA.href;
    }
  });

  // Закрити меню при кліку поза ним
  document.addEventListener('click', function (e) {
    if (!root.contains(e.target)) closeMenu();
  });

  // Клавіші: Enter / Space для переключення поточної мови
  if (currentLi) {
    const currentA = currentLi.querySelector('a');
    if (currentA) {
      currentA.setAttribute('tabindex', '0'); // доступно з клавіатури
      currentA.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggleOpen();
        }
      });
    }
  }
});

document.addEventListener('DOMContentLoaded', () => {

  if (window.innerWidth > 768) {
    const menuItemHasChildren = document.querySelectorAll('.menu-item-has-children');

    menuItemHasChildren.forEach(item => {
      const subMenu = item.querySelector('.sub-menu-grid');
      let hideTimeout;

      item.addEventListener('mouseenter', () => {
        clearTimeout(hideTimeout); // Скасовуємо попереднє ховання
        subMenu.classList.add('open');
      });

      item.addEventListener('mouseleave', () => {
        // Даємо невелику паузу, щоб користувач встиг дійти до підменю
        hideTimeout = setTimeout(() => {
          // Якщо курсор не над підменю — ховаємо
          if (!item.matches(':hover') && !subMenu.matches(':hover')) {
            subMenu.classList.remove('open');
          }
        }, 200);
      });

      // Якщо курсор залишає підменю — ховаємо
      subMenu.addEventListener('mouseleave', () => {
        hideTimeout = setTimeout(() => {
          if (!item.matches(':hover') && !subMenu.matches(':hover')) {
            subMenu.classList.remove('open');
          }
        }, 200);
      });

      // Якщо курсор повернувся у підменю — скасовуємо ховання
      subMenu.addEventListener('mouseenter', () => {
        clearTimeout(hideTimeout);
      });
    });
  } else {

    const menuItemHasChildren = document.querySelectorAll('.menu-item-has-children');
    menuItemHasChildren.forEach(item => {
      const subMenu = item.querySelector('.sub-menu-grid');
      const suba = item.querySelector('.menu-item--animated');
      // let hideTimeout;

      suba.addEventListener('click', (e) => {
        e.preventDefault();
        subMenu.classList.toggle('open');
      });
    });
  }
});
document.addEventListener('DOMContentLoaded', () => {
  (function () {
    const header = document.querySelector('.header'); // елемент хедера
    if (!header) return;
    const marquee = document.querySelector('#marquee'); // елемент хедера

    let lastScroll = 0;
    let ticking = false;
    const offsetShow = marquee.offsetHeight;
    const hideThreshold = 10;

    function onScroll() {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

      // якщо майже не скролимо — не змінюємо стан
      if (Math.abs(currentScroll - lastScroll) < hideThreshold) {
        ticking = false;
        return;
      }

      // додаємо/знімаємо клас липкості
      if (currentScroll > offsetShow) {
        header.classList.add('is-sticky');
      } else {
        header.classList.remove('is-sticky');
      }

      // якщо скролимо вниз і пройшли хедер — ховаємо
      if (currentScroll > lastScroll && currentScroll > offsetShow) {
        header.classList.add('is-hidden');
      } else {
        // скролимо вгору — показуємо
        header.classList.remove('is-hidden');
      }

      lastScroll = currentScroll <= 0 ? 0 : currentScroll; // запобігаємо від'ємним значенням
      ticking = false;
    }

    // опрацювання scroll через requestAnimationFrame для продуктивності
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(onScroll);
        ticking = true;
      }
    }, { passive: true });

    // опціонально: показати хедер при resize (перерахувати висоту)
    window.addEventListener('resize', function () {
      // оновлюємо бар'єр у разі зміни розміру
      // (необхідно, якщо висота хедера змінюється адаптивно)
      // eslint-disable-next-line prefer-destructuring
      // (невеликий дебаунс не потрібен тут, коротко)
      // Перерахунок:
      // Викликаємо через rAF, щоб не блокувати UI
      window.requestAnimationFrame(() => {
        // якщо висота змінилась — оновлюємо змінну
        // (не оголошено const, тому перезаписати неможливо; для простоти просто перезапускаємо)
        // У складніших випадках зробіть offsetShow змінною в зовнішній області
      });
    });
  })();
});

document.addEventListener('DOMContentLoaded', () => {
  const getSiteUrl = document.querySelectorAll('.get-site-url');
  if (getSiteUrl) {
    getSiteUrl.forEach(element => {
      element.addEventListener('click', () => {
        const siteUrlInput = element.closest('.url-wr').querySelector('.site-url');
        setTimeout(() => {
          const siteUrl = siteUrlInput.value;
          const popupInput = document.querySelectorAll('.wpcf7-url');
          popupInput.forEach(element => {
            element.value = siteUrl;
          });
        }, 300);
      });
    })

  }
});

document.addEventListener('DOMContentLoaded', () => {
  const marquee = document.getElementById('marquee');
  const clone = marquee.cloneNode(true);
  marquee.parentNode.appendChild(clone); // додаємо клон після оригіналу

})
document.addEventListener('DOMContentLoaded', () => {
  const trafficChartInfo = document.querySelectorAll('.traffic-chart-info');

  if (trafficChartInfo.length !== 0) {
    trafficChartInfo.forEach(info => {
      const parent = info.closest('.traffic-chart__item');
      const column = parent.querySelector('.traffic-chart__column');

      // parent.addEventListener('click', () => {
      //   // Якщо тултіп вже активний — ховаємо
      //   if (info.classList.contains('active')) {
      //     info.classList.remove('active');
      //     column.classList.remove('active');
      //     info.style.left = '';
      //     info.style.right = '';
      //     info.style.transform = '';
      //     return;
      //   }

      //   // Скидаємо всі інші активні тултіпи і колонки
      //   document.querySelectorAll('.traffic-chart-info.active').forEach(el => {
      //     el.classList.remove('active');
      //     el.style.left = '';
      //     el.style.right = '';
      //     el.style.transform = '';
      //   });
      //   document.querySelectorAll('.traffic-chart__column.active').forEach(el => {
      //     el.classList.remove('active');
      //   });

      //   // Додаємо активний стан
      //   info.classList.add('active');
      //   column.classList.add('active');

      //   // Перевіряємо позицію відносно wrapper
      //   const rect = info.getBoundingClientRect();
      //   const wrapperEl = parent.closest('.simplebar-content-wrapper');
      //   const wrapper = wrapperEl.getBoundingClientRect();

      //   // if (window.innerWidth < 545) {
      //   if (rect.left < wrapper.left) {
      //     info.style.left = '100%';
      //     info.style.transform = 'translateX(0)';
      //   }
      //   if (rect.right > wrapper.right) {
      //     info.style.left = 'auto';
      //     info.style.right = '100%';
      //     info.style.transform = 'translateX(0)';
      //   }


      //   //Прокрутка, щоб тултіп був у зоні видимості
      //   info.scrollIntoView({
      //     behavior: 'smooth',
      //     block: 'nearest',
      //     inline: 'nearest'
      //   });
      //   // }
      // });
      parent.addEventListener('mouseenter', () => {
        info.classList.add('active');
        column.classList.add('active');

        // Перевіряємо позицію відносно wrapper
        const rect = info.getBoundingClientRect();
        const wrapperEl = parent.closest('.simplebar-content-wrapper');
        const wrapper = wrapperEl.getBoundingClientRect();

        // if (window.innerWidth < 545) {
        if (rect.left < wrapper.left) {
          info.style.left = '100%';
          info.style.transform = 'translateX(0)';
        }
        if (rect.right > wrapper.right) {
          info.style.left = 'auto';
          info.style.right = '100%';
          info.style.transform = 'translateX(0)';
        }


        //Прокрутка, щоб тултіп був у зоні видимості
        info.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest'
        });
        // }
      });

      parent.addEventListener('mouseleave', () => {
          info.classList.remove('active');
          column.classList.remove('active');
          info.style.left = '';
          info.style.right = '';
          info.style.transform = '';

        // Скидаємо всі інші активні тултіпи і колонки
        // document.querySelectorAll('.traffic-chart-info.active').forEach(el => {
        //   el.classList.remove('active');
        //   el.style.left = '';
        //   el.style.right = '';
        //   el.style.transform = '';
        // });
        // document.querySelectorAll('.traffic-chart__column.active').forEach(el => {
        //   el.classList.remove('active');
        // });

      });
    });

    // Ховаємо тултіп і прибираємо обводку по кліку поза графіком
    document.addEventListener('click', e => {
      if (!e.target.closest('.traffic-chart__item')) {
        document.querySelectorAll('.traffic-chart-info.active').forEach(el => {
          el.classList.remove('active');
          el.style.left = '';
          el.style.right = '';
          el.style.transform = '';
        });
        document.querySelectorAll('.traffic-chart__column.active').forEach(el => {
          el.classList.remove('active');
        });
      }
    });
  }
});


